import { useQuery } from './common'

/**
 * resourcepage_title~resource_type~resource_content~resource_position~product_position~filter
 */
export function useSensors() {
    const query = useQuery()
    const sensors_string = query?.gf
    if (!sensors_string) return null
    const [
        resourcepage_title,
        resource_type,
        resource_content,
        resource_position,
        product_position,
        filter
    ] = sensors_string?.split('~')

    return {
        resourcepage_title,
        resource_type,
        resource_content,
        resource_position,
        product_position,
        filter
    }
}